import { FileCategory } from "./binder-file";

export class DocSyncStatus {
    printSync: boolean;
    wrongState: boolean;
    signReady: boolean;
    unsyncedDocs: FileCategory[];
  
    constructor() {
        this.printSync = false;
        this.unsyncedDocs = [];
        this.wrongState = false;
        this.signReady = false;
    }
  }